import { TrendingTickerType } from '~/utils/constants/trendingTickerTypes';

// TODO name and scope this more clearly
const MUTATION_NAMES_BY_TYPE = {
  [TrendingTickerType.GAINERS]: {
    loading: 'SET_TRENDING_GAINERS_TICKERS_LOADING',
    success: 'SET_TRENDING_GAINERS_TICKERS',
    error: 'SET_TRENDING_GAINERS_TICKERS_ERROR',
  },
  [TrendingTickerType.LOSERS]: {
    loading: 'SET_TRENDING_LOSERS_TICKERS_LOADING',
    success: 'SET_TRENDING_LOSERS_TICKERS',
    error: 'SET_TRENDING_LOSERS_TICKERS_ERROR',
  },
  [TrendingTickerType.ALL]: {
    loading: 'SET_TRENDING_TICKERS_LOADING',
    success: 'SET_TRENDING_TICKERS',
    error: 'SET_TRENDING_TICKERS_ERROR',
  },
};

export default {
  init(context) {
    context.commit('INIT');
  },
  getTrendingTickers(context, payload) {
    const { trendingType } = payload;
    const {
      loading: loadingMutationName,
      success: fetchSuccessMutationName,
      error: errorMutationName,
    } = MUTATION_NAMES_BY_TYPE[trendingType];

    context.commit(loadingMutationName, true);

    return this.dispatch('api/getTrendingTickers', payload)
      .then((res) => {
        context.commit(fetchSuccessMutationName, res.data);
      })
      .catch((err) => {
        context.commit(errorMutationName, err);
      })
      .finally(() => {
        context.commit(loadingMutationName, false);
      });
  },
};
